import Auth from '../api/auth';
import {
  clearCookiesOnLogout,
  deleteIndexedDBOnLogout,
  extractAuthHeaders,
  hasRequiredAuthHeaders,
  storeAuthHeaders,
} from '../store/utils/api';

let forcedLogoutInProgress = false;

const shouldForceLoginRedirect = error =>
  error?.response?.status === 401 && error?.response?.data?.logout === true;

const forceLogoutToLoginPage = () => {
  if (forcedLogoutInProgress) return;
  forcedLogoutInProgress = true;

  Promise.resolve(deleteIndexedDBOnLogout())
    .catch(() => {
      // Best effort cleanup; continue redirect flow even if IndexedDB delete fails.
    })
    .finally(() => {
      clearCookiesOnLogout('/app/login');
    });
};

const parseErrorCode = error => {
  if (shouldForceLoginRedirect(error)) {
    forceLogoutToLoginPage();
  }
  return Promise.reject(error);
};

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });

  const syncRotatedAuthHeaders = response => {
    const authHeaders = extractAuthHeaders(response?.headers);
    if (hasRequiredAuthHeaders(authHeaders)) {
      storeAuthHeaders(authHeaders);
      Object.assign(wootApi.defaults.headers.common, authHeaders);
    }
    return response;
  };

  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => syncRotatedAuthHeaders(response),
    error => parseErrorCode(error)
  );
  return wootApi;
};
